import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { MatPaginator as MatPaginator, MatPaginatorIntl as MatPaginatorIntl, PageEvent as PageEvent } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';
import { Control } from 'src/models/control';
import { User } from 'src/models/user';
import { HelperService } from 'src/services/helperService';

import { CustomPaginator } from '../administration/CustomPaginatorConfiguration';
import { ChangeStateUserDialog } from './Dialogs/change-state-user/change-state-user.dialog';
import { APIUserManagamentService } from 'src/services/api-services/api-user-Management';
import { tap } from 'rxjs';
import { UserManagement } from 'src/services/api-services/api-interfaces/userManagement.interface';
import { EditInfoUserDialog } from './Dialogs/edit-user/edit-info-user.dialog';
import { CreateUserDialog } from './Dialogs/create-user/create-user.dialog';
import { DeleteUserDialog } from './Dialogs/delete-user/delete-user.dialog';

// ViewEncapsulation.None is takes only local sass styles
@Component({
    selector: 'app-users',
    templateUrl: './users.component.html',
    styleUrls: ['./users.component.sass'],
    encapsulation: ViewEncapsulation.None,
    providers: [
        { provide: MatPaginatorIntl, useValue: CustomPaginator() }
    ],
    standalone: false
})
export class UsersComponent implements OnInit {
  @ViewChild(MatPaginator) paginator?: MatPaginator;
  pagesize: number = 16;
  desde: number = 0;
  hasta: number = 16;
  pagesCount: number = 0;
  selectedPage: number = 0;
  rowPerPage: number = 16;
  paginatorLength: number= 0
  FilterEmail:string = "";
  FilterState:string = "";
  FilterNameUser:string = "";
  FilterCountry:string = "";
  FilterRol:string = "";
  user:User= this.helperService.user
  id= this.user.retailId? this.user.retailId:""
  UsersData:UserManagement[]=[]
  UserLoading:boolean = false
  roleId= this.helperService.user.role.roleId

  constructor(
    public helperService: HelperService,
    public dialog: MatDialog,

    private translate: TranslateService,
    public UserManagamentService:APIUserManagamentService
  )
   {
   }
  onAddControlClick = (param: string): void => {};



  ngOnInit(): void {
    this.pagesize = 16
    this.desde = 0
    this.hasta = this.pagesize
    this.UserLoading = false
    this.helperService.TitlePage ='AdminUsers'
    this.helperService.icon = 'perm_identity';
    this.getUserManagement()

  }

  getUserManagement(){
    if(this.roleId === 4){
      this.UserManagamentService.getUsterByRetail(this.id!, this.helperService.TokenBooking).pipe(tap((response) => {this.UsersData = response
        this.UsersData.map((user) =>{
          return user.roleName= this.translate.instant(user.roleName.toString());
        })
        this.paginatorLength = response.length
        this.UserLoading =  true
      })).subscribe({
        error: (error) => {
          // Validation 401 error
          if(error.status === 401){
            this.helperService.logoutToken()
          }
        }
      })
    }else if (this.roleId === 7){
      this.UserManagamentService.getUsterByRetail('',this.helperService.TokenBooking).pipe(tap((response) => {
        this.UsersData = response
        this.UsersData.map((user) =>{
          return user.roleName= this.translate.instant(user.roleName.toString());
        })
        this.paginatorLength = response.length
        this.UserLoading =  true
      })).subscribe({
        error: (error) => {
          // Validation 401 error
          if(error.status === 401){
            this.helperService.logoutToken()
          }
        }
      });
    }
  }

  // Function Pagination

  changePage(e: PageEvent) {
    this.pagesize = e.pageSize;
    this.desde = e.pageIndex * e.pageSize;
    this.hasta = this.desde + e.pageSize;
  }

  resetPagination(): void {
    this.desde = 0;
    this.hasta = this.pagesize;
    this.paginator?.firstPage();
  }

  // Function show icons hover
  onIconMouseHoverAndOut(
    elementId: string,
    className: string,
    isFill: boolean
  ) {
    if (isFill) {
      document.getElementById(elementId)?.classList.add(className + '-fill');
      document.getElementById(elementId)?.classList.remove(className);
    } else {
      document.getElementById(elementId)?.classList.add(className);
      document.getElementById(elementId)?.classList.remove(className + '-fill');
    }
  }

  controls: Control[] = [
    {
      icon: 'bi bi-plus-lg',
      description: 'Add Workshops',
      action: this.onAddControlClick,
    },
  ];

  // Function Open Dialogs

  ChangeState(user: UserManagement) {
    const dialogRef = this.dialog.open(ChangeStateUserDialog, {
      width: '491px',
      panelClass: 'icon-outside',
      data:user
    });

    dialogRef.afterClosed().subscribe(result => {
      this.ngOnInit()
    });

  }


  createUser() {
    const dialogRef = this.dialog.open(CreateUserDialog, {
      width: '550px',
      panelClass: 'icon-outside',
    });
    dialogRef.afterClosed().subscribe(result => {
     this.ngOnInit()
    });

  }


  EditInfoUser(user: UserManagement) {
    const dialogRef = this.dialog.open(EditInfoUserDialog, {
      width: '550px',
      panelClass: 'icon-outside',
      data: user
    });
    dialogRef.afterClosed().subscribe(result => {
     this.ngOnInit()
    });

  }

  DeleteUser(user:UserManagement) {
    const dialogRef = this.dialog.open(DeleteUserDialog, {
      width: '512px',
      panelClass: 'icon-outside',
      data:user,
    });
    dialogRef.afterClosed().subscribe(result => {
     this.ngOnInit()
    });

  }

  onEditInformationClick(workshop?:any) {

  }

  onDeleteClick(workshop: any) {

  }



}
